import {
  Component,
  EventEmitter,
  Input,
  Output,
  Renderer2,
  SimpleChanges,
} from '@angular/core';
import { PCTableOutputModel } from '../../models/pc-table-input-model';
import { PCTableActionInputModel } from '../../models/pc-table-action-input-model';
import { LoggerService } from 'src/app/services/logger.service';
import { Field } from '../../models/entity-defin';

@Component({
  selector: 'app-pctable-action',
  templateUrl: './pctable-action.component.html',
  styleUrls: ['./pctable-action.component.css'],
})
export class PCTableActionComponent {
  constructor(private renderer: Renderer2, private logger: LoggerService) {
    this.searchField = [];

    this.renderer.listen('window', 'keyup', (e: any) => {
      if (e.key == 'Escape') {
        this.clearSearch();
      }
    });
  }

  @Input() data?: PCTableActionInputModel;
  @Input() header?: Field[];
  @Output() parentAction = new EventEmitter<PCTableOutputModel>();

  public searchColumn?: string = '';
  public searchColumnMessage?: string = undefined;

  public searchValue?: string;
  public searchValueMessage?: string = undefined;

  public searchField: any[];

  public ngOnChanges(changes: SimpleChanges) {
    if (
      changes &&
      changes['header'] &&
      changes['header'].currentValue !== undefined
    ) {
      const newData = changes['header'].currentValue;

      if (newData.length > 0) {
        this.searchField = newData.filter((current) => current.isActiveSearch);
      }
    }
  }

  public callParent(action: string, data: any) {
    this.parentAction.next(new PCTableOutputModel(action, data));
  }

  public clearSearch() {
    this.searchValue = undefined;
    this.searchColumn = '';
    this.callParent('Search', '');
  }

  public letsSearch() {
    let isValid = true;
    if (this.searchColumn == null || this.searchColumn == '') {
      this.searchColumnMessage = 'انتخاب ستون اجباری است';
      isValid = false;
    } else {
      this.searchColumnMessage = undefined;
    }

    if (this.searchValue == null || this.searchValue == '') {
      this.searchValueMessage = 'عبارت سرچ وارد نشده';
      isValid = false;
    } else {
      this.searchValueMessage = undefined;
    }

    if (!isValid) {
      return;
    }

    if (this.searchColumn!.toLowerCase() == 'gtn') {
      const regexBarcode: RegExp =
        /^01(?<GTN>\d{14})21(?<UID>\d{20})17(?<exp>\d{6,8})10(?<lot>.*)$/;
      if (regexBarcode.test(this.searchValue!)) {
        const groups = this.searchValue!.match(regexBarcode)?.groups;
        const searchValue: string = String(groups?.['GTN']);
        this.callParent('Search', this.searchColumn + ':' + searchValue);
        return;
      }
    }

    this.callParent('Search', this.searchColumn + ':' + this.searchValue);
  }
}
